// extracted by mini-css-extract-plugin
module.exports = {"root":"VirtualizedOptions_root__1_Bxo","wrapper":"VirtualizedOptions_wrapper__1jXnx","itemsContainer":"VirtualizedOptions_itemsContainer__NF6Jc"};